import React from 'react';
import Auctions from '../../containers/Auctions/Auctions';

const AuctionsPage = () => {
  return <Auctions />;
};

export default AuctionsPage;
